import React, {Component} from 'react'
import {Control} from 'react-redux-form';
import {connect} from 'react-redux'
import {FormGroup, Grid, Row, Col, Checkbox} from 'react-bootstrap';

import Editor from './editor';

import './styles.css'

class SiteMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteMessage: false,
    };
  }

  setSiteMessage = () => {
    this.setState({
      siteMessage: !this.state.siteMessage
    })
  };



  render() {
    return (
      <Grid bsClass="container" fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox model='.site_message'
                                onChange={this.setSiteMessage}
                                component={Checkbox} >
                Site Message
              </Control.checkbox>
            </FormGroup>

              {this.props.fetched && <Editor content={this.props.siteBody}
                    field="deep.admin_notification_edit.site_body" />}

          </Col>
        </Row>
      </Grid>

    );

  }
}

const mapStateToProps = (state) => {
    return {
        siteBody: state.deep.admin_notification_edit.site_body,
        fetched: state.notifications.fetched,
        fetching: state.notifications.fetching,
    };
};

export default connect(mapStateToProps)(SiteMessage);



// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/site-message-editor.jsx